import { IconButton, Stack, Tooltip } from '@mui/material';
import { Icon } from '../../Atoms/Icon';
import { PermissionSet } from '../../../types';

export interface PermissionSetActionsCellProps {
  permissionSet: PermissionSet;
  onDelete: (set: PermissionSet) => void;
}

export const PermissionSetActionsCell = ({ permissionSet, onDelete }: PermissionSetActionsCellProps) => (
  <Stack
    direction="row"
    spacing={1}>
    <Tooltip title="Delete">
      <IconButton
        size="small"
        aria-label="Delete"
        data-cy="delete-permission-set"
        onClick={() => onDelete(permissionSet)}>
        <Icon type="trash" />
      </IconButton>
    </Tooltip>
  </Stack>
);
